import type { UserLike } from "@habity/types";
import { capitalizeAllWords } from "@habity/utils";

const isPublicUser = (user: UserLike): boolean => {
  return '_isPublic' in user && user._isPublic === true;
};

export const getFullName = (
  user?: UserLike | null,
  fallbackToEmail = true,
) => {
  if (!user) return "Anonymous User";
  const { first_name, last_name } = user || {};
  
  // Public users have empty email, so don't try to use it as fallback
  const email = !isPublicUser(user) && user.email ? user.email : '';
  
  const name =
    first_name || last_name
      ? `${user.first_name ? `${getSingleFirstName(user)}` : ""}${
          user.last_name ? ` ${user.last_name}` : ""
        }`
      : email && fallbackToEmail
        ? email
        : "";
  return capitalizeAllWords(name);
};

export const getTitleCaseIdName = (idName: string) => {
  const splitStr = idName.toLowerCase().split(" ");
  for (let i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
};

export const getSingleFirstName = (user: Partial<UserLike> | null) => {
  if (!user?.first_name) return "(Namnlös)";
  
  const firstName = user.first_name.split(" ")[0].trim();
  return firstName ? capitalizeAllWords(firstName) : "(Namnlös)";
};

export const getInitials = (fullName?: string | null) => {
  const trimmed = (fullName || "").trim();
  if (!trimmed) return null;

  const parts = trimmed.split(/\s+/).filter(Boolean);
  const firstInitial = parts[0]?.[0]?.toUpperCase();
  const lastInitial =
    parts.length > 1 ? parts[parts.length - 1]?.[0]?.toUpperCase() : undefined;
  if (!firstInitial) return null;
  return lastInitial ? `${firstInitial}${lastInitial}` : firstInitial;
};
